import cx from 'classnames';

import {
  Icon,
  V2,
  useTranslation,
  ToolTip,
  SecondaryButton,
} from '@testsigma/atoms';
import classNames from 'classnames';

const { BUTTON_SIZE, BUTTON_VARIANTS, Button } = V2;

export const ReportAgentButton = ({
  onClick,
  className = '',
  iconClassName = '',
  showLabel = false,
  showTooltip = true,
  iconOnly = false,
  isV2 = false,
}) => {
  const { t } = useTranslation();
  const renderIcon = () => (
    <Icon
      name='emergency-home'
      onClick={onClick}
      className={cx('text-base text-secondary-unique-800', iconClassName)}
    />
  );
  const renderContent = () => {
    if (iconOnly) return renderIcon();
    return isV2 ? (
      <Button
        variant={BUTTON_VARIANTS.SECONDARY}
        size={BUTTON_SIZE.SMALLEST}
        className={cx('text-secondary-unique-600', className)}
        onClick={onClick}
      >
        {renderIcon()}
        {showLabel && <span>{t('agent.report_agent')}</span>}
      </Button>
    ) : (
      <SecondaryButton
        className={cx('text-secondary-unique-600', className)}
        onClick={onClick}
      >
        {' '}
        {renderIcon()}
        {showLabel && <span>{t('agent.report_agent')}</span>}
      </SecondaryButton>
    );
  };

  if (!showTooltip) return renderContent();

  return (
    <ToolTip
      content={t('agent.report_agent')}
      className={classNames({ 'h-7': isV2 })}
    >
      {renderContent()}
    </ToolTip>
  );
};
